import { ArrowUpRight } from 'lucide-react'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Logo from '../components/Logo';

const Footer = ({ t }) => {

  const currentYear = new Date().getFullYear();


  const gradient = {
    background: "linear-gradient(to bottom, #2D085C, #5413A6)",
    position: 'relative', zIndex:2
  };

  const company = [
    "about",
    "features",
    // "jobs",
    // "affiliates",
    // "pricing"
  ]

  const resources = [
    // "travel_guides",
    // "tips",
    // "api_developers",
    // "newsletter",
    "FAQ"
  ]

  const support = [
    "contact",
    // "live_chat",
    // "help_desk",
    // "travel_alerts"
  ]

  const media = [
    // { label: "Instagram", href: "#" },
    { label: "Facebook", href: "#" },
    // { label: "TikTok", href: "#" },
    { label: "Twitter", href: "#" },
    { label: "LinkedIn", href: "#" },
    { label: "YouTube", href: "#" },
  ]

  return (

    <footer style={gradient} className='w-100 text-white py-5'>
      <div className='container-xl py-3'>
        <Row>
          <Col xs="6" md="4" lg="3">
            <div>
              <Logo isWhite={true} />
            </div>
          </Col>
        </Row>
        <Row className='mt-5 row-gap-4'>

          <Col lg="8">
            <Row className='row-gap-4'>
              <Col sm="4">
                <>
                  <div className='fw-medium' style={{ fontSize: '110%' }}>{t('company')}</div>
                  <div className='d-flex flex-column gap-2 mt-3'>
                    {company.map((item,index) => (
                      <a className='text-white opacity-75' href={item} key={index}>{t(item)}</a>
                    ))}
                  </div>
                </>
              </Col>

              <Col sm="4">
                <>
                  <div className='fw-medium' style={{ fontSize: '110%' }}>{t('support')}</div>
                  <div className='d-flex flex-column gap-2 mt-3'>
                    {support.map((item,index) => (
                      <a className='text-white opacity-75' href={item} key={index}>{t(item)}</a>
                    ))}
                  </div>
                </>
              </Col>

              <Col sm="4">
                <>
                  <div className='fw-medium' style={{ fontSize: '110%' }}>{t('resources')}</div>
                  <div className='d-flex flex-column gap-2 mt-3'>
                    {resources.map((item,index) => (
                      <a className='text-white opacity-75' href={item} key={index}>{t(item)}</a>
                    ))}
                  </div>
                </>
              </Col>
            </Row>
          </Col>

          <Col lg="4">
            <>
              <div className='fw-medium' style={{ fontSize: '110%' }}>{t('social_media')}</div>
              <div className='d-flex flex-wrap gap-3 mt-3'>
                {media.map((item,index) => (
                  <a className='text-white opacity-75 d-flex align-items-center gap-1' key={index} href={item.href}>
                    <span>{t(item.label)}</span>
                    <span><ArrowUpRight size={20} strokeWidth={1.5} /></span>
                  </a>
                ))}
              </div></>
          </Col>
        </Row>

        <Row className='mt-5 row-gap-4'>
          <Col md="6">
            <div>© {currentYear} {t('all_rights_reserved')}</div>
          </Col>
          <Col md="6">
            <div className='d-flex justify-content-end gap-4'>
              {/* {["privacy_policy", "terms_and_conditions", "join_us"].map((item,index) => ( */}
              {["privacy_policy", "terms_and_conditions"].map((item,index) => (
                <a className='text-white opacity-75' href={item} key={index}>
                  {t(item)}
                </a>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </footer>

  )
}

export default Footer
